import PropTypes from 'prop-types'
import cnames from 'classnames'

const CloseModalButton = ({ className, onClick, isColorWhite }) => {
  const classname = cnames('btn-close', { 'btn-close-white': isColorWhite }, className)

  return (
    <button aria-label="Close" className={classname} id="x-site-tax-setting-usetiful-modal" name="Close"
            onClick={onClick} type="button" />
  )
}

CloseModalButton.defaultProps = {
  isColorWhite: false,
}

CloseModalButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isColorWhite: PropTypes.bool,
}

export default CloseModalButton
